import type { Offering } from "@/lib/types/database/offerings";
import { formatCurrency } from "@wtc/ui/lib/currency";

export const offeringTitleTemplate = (offering: Offering) => offering.title;

export const offeringDescriptionTemplate = (offering: Offering) => {
  // Prefer pricing_display for product offerings (specific tools with estimated costs)
  if (offering.pricing_display) {
    const parts = [offering.pricing_display];
    if (offering.cta_text) parts.push(`• ${offering.cta_text}`);
    if (offering.linked_project_slug) parts.push(`• ${offering.linked_project_slug}`);
    return parts.join(" ");
  }
  // Fallback for project-based offerings with staff/cost line items
  const costFormatted = formatCurrency(Number(offering.total_cost || 0), { currency: "USD", fallback: "", minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${costFormatted} • ${Number(offering.total_hours || 0).toFixed(1)} hours`;
};
